import { locationMasterService } from "../services/LocationMasterService";

export const locationActions = {
  getAllRegions,
  getStateDDL,
  addState,
  addDistrict,
  getDistrictDDL,
  AddTown,
  GetAllLocation
};

// Action to get all regions
function getAllRegions() {
  return (dispatch) => {
    dispatch({ type: "FETCH_REGIONS_REQUEST" });
    return locationMasterService.GetRegionDll()
    
      .then((response) => {
        debugger
        if (response.ResponseCode === "200") {
          // Ensure the data is in the correct format
          const formattedRegions = response.ResponseData.map(item => ({
            label: item.label,
            value: item.value
          }));
          dispatch({ type: "FETCH_REGIONS_SUCCESS", payload: formattedRegions });
          return formattedRegions;
        } else {
          throw new Error(response.ResponseMessage || "Failed to load regions");
        }
      })
      .catch((error) => {
        dispatch({ type: "FETCH_REGIONS_FAILURE", error: error.message });
        throw error;
      });
  };
}

// Action to get states by regionId
function getStateDDL(regionId) {
  return (dispatch) => {
    dispatch({ type: "FETCH_STATES_REQUEST" });
    return locationMasterService.getStateDDL(regionId)
      .then((response) => {
        if (response.ResponseCode === "200") {
          // Format states data to match expected structure
          const formattedStates = response.ResponseData.map(item => ({
            label: item.StateName || item.label || 'Unknown',
            value: item.StateId || item.value || item
          }));
          dispatch({ type: "FETCH_STATES_SUCCESS", payload: formattedStates });
          return formattedStates;
        } else {
          throw new Error(response.ResponseMessage || "Failed to load states");
        }
      })
      .catch((error) => {
        dispatch({ type: "FETCH_STATES_FAILURE", error: error.message });
        throw error;
      });
  };
}
function getDistrictDDL (regionId) {
  return (dispatch) => {
    dispatch({ type: "FETCH_STATES_REQUEST" });
    return locationMasterService.getDistrictDDL(regionId)
      .then((response) => {
        if (response.ResponseCode === "200") {
          // Format states data to match expected structure
          const formattedStates = response.ResponseData.map(item => ({
            label: item.StateName || item.label || 'Unknown',
            value: item.StateId || item.value || item
          }));
          dispatch({ type: "FETCH_STATES_SUCCESS", payload: formattedStates });
          return formattedStates;
        } else {
          throw new Error(response.ResponseMessage || "Failed to load states");
        }
      })
      .catch((error) => {
        dispatch({ type: "FETCH_STATES_FAILURE", error: error.message });
        throw error;
      });
  };
}
function addState(payload) {
  return (dispatch) => {
    dispatch({ type: "ADD_STATE_REQUEST" });
    return locationMasterService.addState(payload)
      .then((response) => {
        if (response.ResponseCode === "200") {
          dispatch({ type: "ADD_STATE_SUCCESS", payload: response });
          return response;
        } else {
          throw new Error(response.ResponseMessage || "Failed to add state");
        }
      })
      .catch((error) => {
        dispatch({ type: "ADD_STATE_FAILURE", error: error.message });
        throw error;
      });
  };
}
function addDistrict(payload) {
  return (dispatch) => {
    dispatch({ type: "ADD_STATE_REQUEST" });
    return locationMasterService.addDistrict(payload)
      .then((response) => {
        if (response.ResponseCode === "200") {
          dispatch({ type: "ADD_STATE_SUCCESS", payload: response });
          return response;
        } else {
          throw new Error(response.ResponseMessage || "Failed to add state");
        }
      })
      .catch((error) => {
        dispatch({ type: "ADD_STATE_FAILURE", error: error.message });
        throw error;
      });
  };
}
function AddTown(payload) {
  return (dispatch) => {
    dispatch({ type: "ADD_STATE_REQUEST" });
    return locationMasterService.addTown(payload)
      .then((response) => {
        if (response.ResponseCode === "200") {
          dispatch({ type: "ADD_STATE_SUCCESS", payload: response });
          return response;
        } else {
          throw new Error(response.ResponseMessage || "Failed to add state");
        }
      })
      .catch((error) => {
        dispatch({ type: "ADD_STATE_FAILURE", error: error.message });
        throw error;
      });
  };
}
function GetAllLocation(request = { search: "", pageNumber: 1, pageSize: 10,sortField:"",sortOrder:"ASC" }) {
return (dispatch) => {
  dispatch({ type: "ADD_STATE_REQUEST" });
  return locationMasterService.getAllLoation(request)
    .then((response) => {
      if (response.ResponseCode === "200") {
        dispatch({ type: "ADD_STATE_SUCCESS", payload: response });
        return response;
      } else {
        throw new Error(response.ResponseMessage || "Failed to add state");
      }
    })
    .catch((error) => {
      dispatch({ type: "ADD_STATE_FAILURE", error: error.message });
      throw error;
    });
}
}

